import { render, staticRenderFns } from "./ManagementGuideContentItem.vue?vue&type=template&id=8b2906c2&scoped=true&"
import script from "./ManagementGuideContentItem.vue?vue&type=script&lang=js&"
export * from "./ManagementGuideContentItem.vue?vue&type=script&lang=js&"
import style0 from "./ManagementGuideContentItem.vue?vue&type=style&index=0&id=8b2906c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2906c2",
  null
  
)

export default component.exports